<div class="contact-select">
  <div class="contact-select__field" :class="{ 'has-clear': showClear }">
    <app-text-input
      :model-value="searchText"
      :placeholder="placeholder"
      :readonly="readonly"
      :icon="readonly ? '' : 'search'"
      autocomplete="off"
      @update:model-value="onTextInput"
      @focus="openDropdown"
      @blur="onBlur"
    />
    <button
      v-if="showClear"
      type="button"
      class="contact-select__clear"
      aria-label="Clear customer"
      @mousedown.prevent="clear"
    >
      <i class="close icon" aria-hidden="true"></i>
    </button>
  </div>
  <div
    class="contact-dropdown"
    v-show="open && !readonly && (options.length > 0 || loading)"
  >
    <div class="contact-dropdown__loader ui active inline loader mini" v-if="loading"></div>
    <ul class="contact-dropdown__list" v-else>
      <li
        v-for="(opt, idx) in options"
        :key="(opt && (opt.id != null ? opt.id : opt.uuid)) || 'opt-' + idx"
        class="contact-dropdown__item"
        @mousedown.prevent="select(opt)"
      >{{ getDisplayName(opt) }}</li>
    </ul>
  </div>
</div>
